import React from 'react';
import Nav from './nav/Nav';
import List from './list/List';
import ListHome from './list-home/ListHome';
import PullOnLoading from 'common/components/pull-on-loading/PullOnLoading';
import $ from 'jquery';
import conf from 'common/js/conf';
import utils from 'common/js/utils';
import report from 'common/js/report';
import logger from 'common/js/logger';
import wxApi from 'common/js/wxapi';
import DataTips from 'common/components/data-tips/DataTips';
import immutable from 'immutable';

const appId = utils.appId;//获得渠道号
const _gid = utils.gid;//获得gid
const _tid = utils.tid;//获得tid
const yanzhiGid = conf.gid.yanzhi;
const xingxiuGid = conf.gid.xingxiu;
const MAX_PAGE_NUM = 30;
var className = null;

export default class Index extends React.Component {
    static data = [];
    static cacheData = {};
    static cacheTag = [];//一级分类
    static cacheTagList = {};//包括二级标签信息
    static gId = _gid || -2;
    static tid = _tid || 0;
    static isMore = true;
    static inited = false;
    static page = 1;

    constructor(props){
        super(props);
        this.searchString = props.location.search;
        this.loading = false;
        this.tabChanged =  false;//是否切换了tab
        this.page = Index.page;
        
        let nowData = Index.cacheData[ Index.gId === -1 ? '-1_116' :  Index.gId] || [];
        Index.inited = nowData.length > 0 ? Index.inited : false;
        this.state = {
            data: nowData,//当前渲染的数据
            isMore: Index.isMore,//是否还有下一页
            inited: Index.inited,//是否初始化过
            openLocation: null,//是否打开了定位
            tags: Index.cacheTag,//标签列表
            gId: Index.gId,//当前正在加载的标签id
            tId: Index.tid//当前正在加载的tid
        };

        this._setState =  this._setState.bind(this);
        this.getData = this.getData.bind(this);
        this.getTypes =  this.getTypes.bind(this);
        this.getTags =  this.getTags.bind(this);
        this.changeType = this.changeType.bind(this);
        this.changeTag = this.changeTag.bind(this);
        this.getLocation = this.getLocation.bind(this);

        this.initXingxiuData = this.initXingxiuData.bind(this);
        this.getYanzhiData = this.getYanzhiData.bind(this);

        this.handleMoreTags = this.handleMoreTags.bind(this);

        utils.setDocTitle();
        wxApi.init();
        wxApi.setWXShareInfo();

    }

    componentWillMount() {
        this.props.showComComponent && this.props.showComComponent();
    }

    componentDidMount() {
        this._isMounted = true;

        if(className && this.refs.indexPage){
            this.refs.indexPage.className = className;
        }
        
        if( !Index.inited ) {
            if (Index.cacheTag && Index.cacheTag.length === 0) {
                this.getData();
                this.getTypes((gId) => {
                    this.getData(gId);
                });
            } else {
                this.getData();
            }
        }

        report.reportPageView({
            eid:'Pageview/home',
            eid_desc: 'Pageview/首页'
        });

    }

    componentWillUnmount() {
        this._isMounted = false;
        Index.page = this.page;
        className = this.refs.indexPage.className;
        report.stopPageView();
    }
    _setState(newState){
        if( this._isMounted ){
            this.setState(newState || {});
        }
    };
    //把六个颜值数据塞到星秀前面
    initXingxiuData( cb ){

        if( !this.yanzhiData ){
            this.getYanzhiData(cb);
        }else{
            cb && cb();
        }
    }
    getYanzhiData( cb ){
        const gId = yanzhiGid;
        $.ajax({
            url: conf.dataUrls.indexTypeLiveData,
            data: {
                appId: appId,
                data: JSON.stringify({
                    page: 1,
                    gid: gId,
                    pageSize: MAX_PAGE_NUM
                })
            },
            dataType: 'jsonp',
            jsonpCallback: 'getYanzhiData',
            cache: true
        }).done( (res) => {

            if (!this._isMounted) return;

            if (res.status === 200 || res.statusCode === 200) {

                const data = res.data.list || res.data.datas || [];

                if (data.length > 0) {
                    Index.cacheData[gId] = utils.unique([].concat(data), 'uid');
                    this.yanzhiData = Index.cacheData[gId].slice(0,30);
                }
                cb && cb();
            }
        })
    }
    /**
     * 切换标签 1次setState
     */
    changeType( gId, tId ,isGetData = true){

        this.refs.indexPage && this.refs.indexPage.classList.remove('index-page-two-bar');

        this.isTag = false;
        var changedState = {};
        if( this._isMounted ){
            this.tabChanged = !(Index.gId == gId);
            if( this.tabChanged ){
                document.body.scrollTop = 0;
                this.page = 1;

                changedState.inited = Index.inited = false;
                changedState.isMore = Index.isMore = true;
                changedState.data = Index.data = Index.cacheData[gId] || [];
                changedState.gId = Index.gId = gId;

                Index.cacheData[gId] = [];
                this._setState(changedState);
            }

            if(isGetData){
                this.getData(gId, tId);
            }
        }
    }
    /**
     * 切换标签
     */
    changeTag(gId, tId ){

        if( this._isMounted ){
            document.body.scrollTop = 0;
            this.page = 1;

            var changedState = {};
            changedState.inited = Index.inited = false;
            changedState.isMore = Index.isMore = true;
            changedState.tId = Index.tId = tId;

            this._setState(changedState);
        }

        this.isTag = true;
        this.tagId =  tId;
        this.gId =  gId;
        this.getData(this.gId, tId);

    }
    /**
     * 获取分类下的全部表情 1次setState
     */
    getTags( gId , cb){
        var list = [];
        if(gId < 0) return;

        $.ajax({
            url: conf.dataUrls.indexTypeTags,
            data: {
                gid: gId,
                appId: appId
            },
            dataType: 'jsonp',
            jsonpCallback: 'getIndexTypeTages',
            cache: true
        }).done( (res)=>{
            if( res.statusCode === 200 ){
                const tags = Index.cacheTagList[gId] = res.data || [];

                if( tags.length > 0){
                    this.refs.indexPage && this.refs.indexPage.classList.add('index-page-two-bar');
                }
                cb && cb(tags);
            }
        });
    }
    /**
     * 多个子标签
     */
    handleMoreTags(){
        this.refs.indexPage && this.refs.indexPage.classList.add('index-page-two-bar');
    }
    /**
     * 获取分类下的直播数据 1次setState
     */
    getTypes( cb ) {
        $.ajax({
            url: conf.dataUrls.indexTypeTags,
            data: {appId: appId},
            dataType: 'jsonp',
            jsonpCallback: 'getIndexTypeTages',
            cache: true
        }).done( (res)=>{
            if( this._isMounted && res.statusCode === 200 ){
                let defaultType = [
                    {name:'推荐', gid: -2, tagId: 0, subList: []},
                    //{name:'热舞', gid: -1, subList: []}
                ]
                const list = Index.cacheTag = [].concat(defaultType, res.data || []);
                //var gId = Index.gId = ( list[0] && +list[0].gid ) || -1;
                //只有一个类别时，不显示nav
                if( list.length === 1){
                    this.refs.indexPage.classList.add('index-page-noBar');
                    this.setState({
                        //gId: gId
                    });
                }else{
                    this.setState({
                        //gId: gId,
                        tags: Index.cacheTag
                    });
                }
            }else{
                this.noData = true;
                this.setState({
                    inited: Index.inited = true
                });

            }
        });
    }
    /**
     * 获取列表数据 1次setState
     */
    getData( gId = Index.gId, tId = Index.tid) {

        if(this.loading) return ;
        if(gId == -2){
            return this.getHomeData(gId);
        }

        this.noData = false;
        this.loading = true;
        var ajaxParams = null;

        //gId = gId || Index.gId;

        ajaxParams = {
            url: conf.dataUrls.indexTagLiveData,
            data: {
                appId: appId,
                data: JSON.stringify({
                    page: this.page,
                    gid: gId,
                    tagId: tId,
                })
            },
            dataType: 'jsonp',
            jsonpCallback: 'getIndexTypeLiveData',
            cache: true

        }


        $.ajax(ajaxParams).done( (res) => {

            if(!this._isMounted) return;

            if( res.status === 200 || res.statusCode === 200) {

                const data = res.data.list || res.data.datas || [];

                if (data.length > 0) {
                    Index.cacheData[gId] = utils.unique(  (Index.cacheData[gId] || [] ).concat(data), 'uid');
                    const totalPage = res.data.totalPage || Math.ceil(res.data.total/MAX_PAGE_NUM);
                    this.setState({
                        data:  Index.cacheData[gId],
                        isMore: Index.isMore  = totalPage > this.page++,
                        inited: Index.inited = true
                    });

                }else{

                    var changeState = {
                        isMore: false,
                        inited: Index.inited = true
                    };
                    if(this.page === 1) {
                        logger.log('暂无数据');
                        this.noData = true;
                        changeState.data = [];
                    }
                    this.setState({
                        state: changeState
                    });
                }
            }else{
                var changeState = {
                    isMore: false,
                    inited: Index.inited = true
                };
                if(this.page === 1) {
                    logger.log('暂无数据');
                    this.noData = true;
                    changeState.data = [];
                }
                this.setState({
                    state: changeState
                });
            }
        }).always( () => {
            this.loading = false;
        });
    }
   
    render() {
        const state = this.state;
        let params = {
            search: this.searchString,
            fLoad: this.getData,
            bIsMore: state.isMore,
            bInited: state.inited,
            aData: immutable.fromJS(state.data)
        };

        var comp = null;
        const gId = +this.state.gId;
       
        if( this.noData === true){
            comp = <DataTips type="noData" txt="该分类暂无主播开播"/>;
        }else{
            if(state.gId == -2){
                comp = (<PullOnLoading {...params}>
                            <ListHome gId={gId}/>
                        </PullOnLoading>);
            }else{
                const yanzhi = gId == yanzhiGid ||  gId == xingxiuGid || gId == -1;
                comp =  (<PullOnLoading {...params}>
                            <List gId={gId} yanzhi={yanzhi}/>
                        </PullOnLoading>);
            }
            
        }

        return (
            <div className="g-con index-page-con" ref="indexPage">
                {this.state.tags.length > 1 ?
                    <Nav
                        gId={this.state.gId}
                        list={immutable.fromJS(this.state.tags)}
                        changeType={this.changeType}
                        changeTag={this.changeTag}
                        getTags = {this.getTags}
                        handleMoreTags = {this.handleMoreTags}
                    /> : null
                }
                {comp}
            </div>
        );
    }
    /**
     * 获取首页数据
     * @param fn 回调函数
     */
    getHomeData(gId){
        if(this.loading) return ;

        this.noData = false;
        this.loading = true;
        var ajaxParams = null;

        gId = gId || Index.gId;
        
        ajaxParams = {
            url: conf.dataUrls.indexHotRecData,
            data: {
                appId: appId
            },
            dataType: 'jsonp',
            jsonpCallback: 'getIndexHotRecData',
            cache: true
        }

        $.ajax(ajaxParams).done( (res) => {

            if(!this._isMounted) return;

            if( res.status === 200 || res.statusCode === 200) {

                let data = res.data.recLives || [];

                if (data.length > 0) {

                    Index.cacheData[gId] = data;
                    
                    this.setState({
                        data:  Index.cacheData[gId],
                        isMore: Index.isMore = false,
                        inited: Index.inited = true
                    });

                }else{

                    var changeState = {
                        data: [],
                        inited: Index.inited = true
                    };

                    logger.log('暂无数据');
                    this.noData = true;

                    this.setState({
                        state: changeState
                    });
                }
            }else{
                var changeState = {
                    data: [],
                    inited: Index.inited = true
                };
    
                logger.log('暂无数据');
                this.noData = true;
    
                this.setState({
                    state: changeState
                });
            }
        }).always( () => {
            this.loading = false;
        });
    }
    /**
     * 获取地理位置
     * @param fn 回调函数
     */
    getLocation( fn ){
        if( Index.cacheLocation ){
            this.setState({
                openLocation: true
            });
            fn && fn();
            return;
        }
        wxApi.getLocation( (rsp)=>{
            if( rsp._returnCode === 1){
                Index.cacheLocation = rsp;
                fn && fn( rsp );
                if( this._isMounted ){
                    this.setState({
                        openLocation: true
                    });
                }

            }else if( rsp._returnCode === 0){
                if( this._isMounted ){
                    this.setState({
                        openLocation: false
                    });
                }
            }else{
                if( this._isMounted ){
                    this.setState({
                        openLocation: false
                    });
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/views/index/Index.jsx